<h2 mat-dialog-title>Testes disponiveis</h2>
<button mat-raised-button color="primary" (click)="openNewTest()">Cadastrar Teste</button>
<mat-dialog-content>

    <mat-tab-group #tabGroup>
        <mat-tab label="Ver resposta dos candidatos" *ngIf="processListTest.length">

            <mat-action-list>
                <button mat-list-item *ngFor="let test of processListTest" [value]="test.id">
                    <h3 matLine (click)="openQuestions(test)">{{ test.name }}</h3>
                    <p matLine (click)="openQuestions(test)">{{ test.description }}</p>
                    <ng-container *ngIf="test.status === 'answered'">
                        <button mat-icon-button color="primary" matTooltip="Corrigir questionário" (click)="openQuestionResponseCorrection(test)">
                            <mat-icon>grading</mat-icon>
                        </button>
                    </ng-container>
                    <ng-container *ngIf="test.status === 'evaluated'">
                        <button mat-icon-button color="primary" matTooltip="Questionário corrigido" (click)="openQuestions(test)">
                            <mat-icon>check_circle_outline</mat-icon>
                        </button>
                    </ng-container>
                </button>
            </mat-action-list>
    
            <!--<div class="empty-content" *ngIf="processListTest.length === 0 && submiting === false">
                <span class="mat-body-2">Nenhum questionário encontrado</span>
            </div>-->

        </mat-tab>

        <mat-tab label="Escolher testes">

            <mat-selection-list #selectionTestList>
                <mat-list-option *ngFor="let test of tests" [value]="test.id" 
                    [selected]="hasProcessListTestSelected(test)"
                    [disabled]="hasProcessListTestPending(test)">
                    <h3 matLine>{{ test.name }}</h3>
                    <p matLine>{{ test.description }}</p>
                </mat-list-option>
            </mat-selection-list>

        </mat-tab>
    </mat-tab-group>

    <!--<p class="mat-body-2" *ngIf="!showResponses">Selecione os teste para ser aplicado</p>-->
    
    <ng-template #testResponses>
        
        
    </ng-template>
    
</mat-dialog-content>
<!-- <mat-progress-bar color="primary" mode="indeterminate" *ngIf="submiting"></mat-progress-bar> -->
<mat-dialog-actions>
    <button mat-button mat-dialog-close color="accent">Fechar</button>
    <ng-container *ngIf="!showResponses">
        <button mat-raised-button color="primary" [disabled]="this.selectionTestList?.selectedOptions.selected.length === 0"
            (click)="saveProcessList()">Continuar</button>
    </ng-container>
</mat-dialog-actions>